export const stdColorLight = "grey-lighten-1";
export const stdColorDark = "grey-darken-1";
export const stdColorSelectedRow = "#FFCDD2"; //red lighten-4: must use Hex-code for HTML-Elements
export const colorCartOn = "green-lighten-1";
export const colorCartOff = stdColorLight;
//export const colorSystemBarOn = "#e30613";
export const colorSystemBarOn = "green-lighten-1";
export const colorSystemBarOff = "#ffffff";

export default class MyColors {
  static get stdColorLight() {
    return stdColorLight;
	}

  static get stdColorDark() {
    return stdColorDark;
  }
  
  static get stdColorSelectedRow() {
    return stdColorSelectedRow;
	}

  static get colorCartOn() {
    return colorCartOn;
	}

  static get colorCartOff() {
    return colorCartOff;
	}
	
  static get colorSystemBarOn() {
    return colorSystemBarOn;
	}
	
  static get colorSystemBarOff() {
    return colorSystemBarOff;
  }
}
